import actionTypes from "constants/notification";
import { Action, ActionFunctionAny, createActions } from "redux-actions";

const { READ_ALL_NOTIFICATIONS, READ_NOTIFICATION, TOGGLE_FAVORITE_NOTIFICATION } = actionTypes;

const actions = createActions(READ_ALL_NOTIFICATIONS, READ_NOTIFICATION, TOGGLE_FAVORITE_NOTIFICATION);

const readAllNotifications = () => (dispatch: ActionFunctionAny<Action<Object>>) =>
    dispatch(actions.readAllNotifications());

const readNotification = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) =>
    dispatch(actions.readNotification(params));

const toggleFavorite = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) =>
    dispatch(actions.toggleFavoriteNotification(params));

export default { ...actions, readAllNotifications, readNotification, toggleFavorite };
